var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',[(_vm.itemsLength > 0)?_c('v-badge',{attrs:{"color":"red","text-color":"white","inline":_vm.inline,"overlap":_vm.overlap,"content":_vm.itemsLength}},[_vm._t("default")],2):[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }